import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=1b270d03&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=ts&"
export * from "./TabView.vue?vue&type=script&lang=ts&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=1b270d03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b270d03",
  null
  
)

export default component.exports